module.exports = __webpack_public_path__ + "img/moutarde.febf4880.svg";